<template>
  <div>
    <ArticleDetail></ArticleDetail>
  </div>
</template>

<script>
import ArticleDetail from "@/components/article/ArticleDetail.vue";

export default {
  name: "ArticleDetailView",
  components: {
    ArticleDetail
  }
};
</script>

<style scoped></style>
